var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditIcon = function SvgEditIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.2929 7.29289C20.6834 6.90237 21.3166 6.90237 21.7071 7.29289L24.7071 10.2929C25.0976 10.6834 25.0976 11.3166 24.7071 11.7071L15.7071 20.7071C15.5196 20.8946 15.2652 21 15 21H12C11.4477 21 11 20.5523 11 20V17C11 16.7348 11.1054 16.4804 11.2929 16.2929L20.2929 7.29289ZM13 17.4142V19H14.5858L22.5858 11L21 9.41421L13 17.4142ZM7 11C7 9.89543 7.89543 9 9 9H14C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H9V23H21V18C21 17.4477 21.4477 17 22 17C22.5523 17 23 17.4477 23 18V23C23 24.1046 22.1046 25 21 25H9C7.89543 25 7 24.1046 7 23V11Z",
    fill: "#2196F3"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "edit-icon.b51d5c067d42041902ad3cf115981fab.svg";